import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectPartner } from "../store/partnerStore";
import { API_KEY_MAP } from "../utils/constants";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";

export const MapPage = () => {
  const { latitude, longitude } = useParams();
  const partner = useSelector(selectPartner);
  // The V2 ScreenHeader is 48px tall; the legacy header bar is 70px (80px below is its
  // long-standing allowance). V2-off partners keep that value exactly.
  const headerOffset = isV2Enabled(V2_SCREEN_KEYS.MAP, partner) ? "48px" : "80px";

  return (
    <div>
      <iframe
        title="Google Maps Location"
        width="100%"
        height="100%"
        style={{
          border: 0,
          minHeight: `calc(100vh - ${headerOffset})`,
        }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${API_KEY_MAP}&q=${latitude},${longitude}`}
      ></iframe>
    </div>
  );
};
